'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _effects = require('redux-saga/effects');

var _webUtils = require('@vezeeta/web-utils');

var _webSso = require('@vezeeta/web-sso');

var _doctor = require('../actions/doctor');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(getRoomBookingInfo),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(getDoctorDetailsSaga),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(doctorSaga);

function getRoomBookingInfo(action) {
  var getRoomBookingInfoApi, doctorsAccountKeys, getRoomBookingInfoApiResponse;
  return _regenerator2.default.wrap(function getRoomBookingInfo$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          getRoomBookingInfoApi = new _webSso.AuthApi();
          doctorsAccountKeys = void 0;

          if (action.payload.doctorAccountKey && action.payload.doctorAccountKey.length) {
            doctorsAccountKeys = action.payload.doctorAccountKey;
          } else {
            doctorsAccountKeys = [action.payload.doctorAccountKey];
          }

          _context.next = 5;
          return getRoomBookingInfoApi.post(_webUtils.Urls.profile, {
            query: 'query usersQuery($userKeys: [String]!)\n        {\n          usersByKeys(userKeys: $userKeys)\n          {\n            userKey\n            userCountryDetails {\n              firstName\n              lastName\n              languageId\n            }\n            userSpecialties {\n              isMainSpecialty\n              specialtyKey\n            }\n            entities {\n              branches {\n                userBranches {\n                  userKey\n                  branchKey\n                  fees\n                }\n              }\n            }\n          }\n        }',
            variables: {
              userKeys: doctorsAccountKeys
            }
          });

        case 5:
          getRoomBookingInfoApiResponse = _context.sent;

          if (!_webUtils.STATUS.isSuccess(getRoomBookingInfoApiResponse.status)) {
            _context.next = 11;
            break;
          }

          _context.next = 9;
          return (0, _effects.put)({
            type: _doctor.DOCTOR.GET_ROOM_BOOKING_INFO.SUCCESS,
            data: getRoomBookingInfoApiResponse.data
          });

        case 9:
          _context.next = 13;
          break;

        case 11:
          _context.next = 13;
          return (0, _effects.put)({
            type: _doctor.DOCTOR.GET_ROOM_BOOKING_INFO.FAIL,
            error: getRoomBookingInfoApiResponse.data
          });

        case 13:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function getDoctorDetailsSaga(action) {
  var api, _action$payload, accountKey, branchKey, response;

  return _regenerator2.default.wrap(function getDoctorDetailsSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          api = new _webUtils.API();
          _action$payload = action.payload, accountKey = _action$payload.accountKey, branchKey = _action$payload.branchKey;
          _context2.next = 4;
          return api.get(_webUtils.Urls.getDoctorDetails + '/' + accountKey + '?BranchKey=' + branchKey);

        case 4:
          response = _context2.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context2.next = 10;
            break;
          }

          _context2.next = 8;
          return (0, _effects.put)((0, _doctor.getDoctorDetailsSuccess)(_extends({}, response)));

        case 8:
          _context2.next = 12;
          break;

        case 10:
          _context2.next = 12;
          return (0, _effects.put)((0, _doctor.getDoctorDetailsFailed)(_extends({}, response)));

        case 12:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function doctorSaga() {
  return _regenerator2.default.wrap(function doctorSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeLatest)(_doctor.DOCTOR.GET_ROOM_BOOKING_INFO.LOAD, getRoomBookingInfo);

        case 2:
          _context3.next = 4;
          return (0, _effects.takeLatest)(_doctor.DOCTOR.GET_Doctor_Details.LOAD, getDoctorDetailsSaga);

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

exports.default = doctorSaga;
module.exports = exports['default'];